import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { Entity, TreeEntity } from '../../../core/models/entity.model';
import { UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';
import type { EntityType } from '../../../core/models/entity-type.model';
import { MultiEditPropertyEditorComponent } from '../multi-edit-property-editor/multi-edit-property-editor.component';

@Component({
  selector: 'app-multi-edit-entity-editor',
  templateUrl: './multi-edit-entity-editor.component.html',
  styleUrls: ['./multi-edit-entity-editor.component.scss'],
  standalone: false
})
export class MultiEditEntityEditorComponent {
  @Input() entity: Entity | TreeEntity;
  @Input() entityForm: UntypedFormGroup;
  @Input() entityType: EntityType;

  @Output() propertyChange = new EventEmitter<EntityEditorPropertyChangedEvent>();

  protected multiEditPropertyComponent = MultiEditPropertyEditorComponent;

  propertyChanged(event: EntityEditorPropertyChangedEvent) {
    this.propertyChange.emit(event);
  }
}
